import { Maybe } from '@lib/types/Maybe';
import c from 'classnames';

import { RichText } from 'ui-components';

type BlocksTitleProps = {
  title?: Maybe<string>;
  description?: string | null; // HTML string
  text?: string | null; // HTML string
  isDarkTheme?: boolean;
};

export const BlocksTitle = ({
  title,
  description,
  text,
  isDarkTheme = false,
}: BlocksTitleProps) => {
  if (text) {
    let textHtmlWithLinebreaks = text.replaceAll('<p></p>', '</br>');

    // remove the last occurrence of <br> to avoid excess bottom spacing
    if (textHtmlWithLinebreaks.endsWith('</br>')) {
      textHtmlWithLinebreaks = textHtmlWithLinebreaks.slice(0, -5);
    }

    return (
      <div className={c({ 'text-white': isDarkTheme })}>
        <RichText html={textHtmlWithLinebreaks} className="block [&_p]:mb-0" />
      </div>
    );
  }

  const descHtmlWithLinebreaks = (description ?? '').replaceAll(
    '<p></p>',
    '</br>'
  );

  return (
    <div className={c({ 'text-white': isDarkTheme })}>
      {title && (
        <h2 data-test="blocks-title" className="header-mid">
          {title}
        </h2>
      )}
      {description && (
        <RichText
          data-test="blocks-title-description"
          html={descHtmlWithLinebreaks}
          className="mt-5 block [&_p]:mb-0"
        />
      )}
    </div>
  );
};
